import { useEffect } from "react";

export interface UseOnClickOutsideOptions {
  enabled?: boolean;
  eventType?: "mousedown" | "click" | "pointerdown";
}

/** Invokes handler when a pointer event occurs outside the provided refs. */
export const useOnClickOutside = (
  refs: Array<React.RefObject<HTMLElement>>,
  handler: (event: MouseEvent) => void,
  options?: UseOnClickOutsideOptions,
): void => {
  useEffect(() => {
    const enabled = options?.enabled ?? true;
    if (!enabled) return;

    const eventType = options?.eventType ?? "mousedown";
    const listener = (event: MouseEvent): void => {
      const target = event.target as Node | null;
      if (!target) return;
      const isInside = refs.some((ref) =>
        ref.current ? ref.current.contains(target) : false,
      );
      if (isInside) return;
      handler(event);
    };

    document.addEventListener(eventType, listener);
    return () => document.removeEventListener(eventType, listener);
  }, [refs, handler, options?.enabled, options?.eventType]);
};
